module.exports = __webpack_public_path__ + "img/thumb_14.a702f731.jpg";